<template lang="pug">

transition(
  appear
)
  .button-switch
    svg(width="100%" viewBox="0 0 74 38" fill="none" xmlns="http://www.w3.org/2000/svg")
      g
        path(stroke="#fff" stroke-width="2" d="M55.69.5H18.31C8.44.5.5,8.93.5,19.12S8.44,37.74,18.31,37.74H55.69c9.87,0,17.81-8.43,17.81-18.62S65.56.5,55.69.5Zm0,35.28H18.31c-8.71,0-15.87-7.45-15.87-16.66S9.6,2.46,18.31,2.46H55.69c8.71,0,15.87,7.45,15.87,16.66S64.4,35.78,55.69,35.78Z")
        path(class="fill" :transform="`translate(${ofs}, 0)`" :d="`M18.7 7 c${-ct1} 0 ${-r1} ${12-ct2} ${-r1} 12 c0 ${ct2} ${r1-ct1} 12 ${r1} 12 h17 c${ct2} 0 ${r2} ${ct1-12} ${r2} -12 c0 ${-ct1} ${ct2-r2} -12 ${-r2} -12 h-17Z`")
        path(class="fill" d="M60.4 20.1C60.4 20.6 59.9 21.1 59.4 21.1H57.9C57.4 21.1 56.9 21.5 56.9 22.1V27C56.9 27.6 56.4 28 55.9 28H55.8C55.3 28 54.8 27.6 54.8 27V22C54.8 21.4 54.3 21 53.8 21H51.8C51.3 21 50.7 21.4 50.6 22L47.3 27.2C46.9 27.6 46.4 27.7 46.1 27.4C45.8 27.1 45.3 26.2 45.7 25.8L48.4 22C48.6 21.5 48.2 21 47.7 21H46C45.5 21 45 20.6 45 20C45 19.4 45.5 19 46 19H47.8C48.3 19 48.8 18.9 48.8 18.7C48.8 18.5 48.8 18 48.8 17.4V16C48.8 15.4 48.3 15 47.8 15H46.5C46 15 45.5 14.6 45.5 14C45.5 13.4 46 13 46.5 13H58.8C59.3 13 59.8 13.4 59.8 14C59.8 14.6 59.3 15 58.8 15H57.8C57.3 15 56.8 15.4 56.8 16V18.1C56.8 18.7 57.3 19.1 57.8 19.1H59.3C59.9 19.1 60.4 19.5 60.4 20.1ZM53.8 19.1C54.3 19.1 54.8 18.7 54.8 18.1V16C54.8 15.4 54.3 15 53.8 15H51.9C51.4 15 50.9 15.4 50.9 16V17.7C50.9 18.3 50.9 18.8 50.9 18.9C50.9 19 51.4 19.1 51.9 19.1H53.8Z")
        path(class="fill" :transform="`translate(-3, -1)`" d="M26.2 22.2002C25.6 22.2002 25.5 22.5002 25.9 22.9002L30.6 25.8002C31.1 26.0002 31.3 26.5002 31 26.9002C30.7 27.3002 29.7 28.0002 29.2 27.8002L24.5 24.5002C24.1 24.1002 23.5 24.1002 23.2 24.5002L17.9 27.9002C17.4 28.1002 16.8 28.0002 16.5 27.7002C16.2 27.4002 15.9 26.4002 16.4 26.1002L21.4 23.0002C21.7 22.6002 21.6 22.2002 21 22.2002H17C16.4 22.2002 16 21.8002 16 21.2002C16 20.6002 16.4 20.2002 17 20.2002H21.4C22 20.2002 22.4 20.2002 22.4 20.1002C22.4 20.0002 22.4 19.6002 22.4 19.0002V18.9002C22.4 18.3002 22 17.9002 21.4 17.9002H18.1C17.5 17.9002 17.1 17.5002 17.1 16.9002C17.1 16.3002 17.5 15.9002 18.1 15.9002H18.9C19.5 15.9002 19.7 15.5002 19.4 15.0002L18.9 14.2002C18.6 13.7002 18.7 13.2002 19.2 12.9002C19.7 12.6002 20.3 12.8002 20.6 13.3002L21.3 14.4002C21.6 14.9002 21.5 15.4002 21.3 15.6002C21.1 15.8002 21.2 15.9002 21.8 15.9002H23.9C24.5 15.9002 25.1 15.5002 25.4 15.0002L26.2 13.4002C26.4 12.9002 27 12.6002 27.6 12.8002L27.9 12.9002C28.4 13.1002 28.6 13.6002 28.3 14.1002L27.7 15.1002C27.4 15.6002 27.6 15.9002 28.2 15.9002H29C29.6 15.9002 30 16.3002 30 16.9002C30 17.5002 29.6 17.9002 29 17.9002H25.7C25.1 17.9002 24.7 18.3002 24.7 18.9002V19.1002C24.7 19.7002 24.7 20.1002 24.7 20.2002C24.7 20.3002 25.1 20.3002 25.7 20.3002H29.9C30.5 20.3002 30.9 20.7002 30.9 21.3002C30.9 21.9002 30.5 22.3002 29.9 22.3002H26.2V22.2002Z")


</template>

<script>

export default {
  name: 'button-switch',
  components: {},
  data() {
    return {
      progress:0,
      ofs: 0,
      tl: null
    }
  },
  props: {
    initState: {
      required: true
    }
  },
  computed: {

    ct1(){
      return 8
    },
    ct2(){
      return 5
    },
    r1(){
      return 12-this.progress*7
    },
    r2(){
      return 5+this.progress*7
    },

  },
  beforeMount(){
    if (!this.initState) {
      this.progress = 1
      this.ofs = 19
    }else{
      this.progress = 0
      this.ofs = 0
    }
  },
  mounted() {

  },
  beforeDestroy() {},
  methods: {

    animateOff() {
      if (this.tl)
        this.tl.kill()
      let tl = new TimelineMax({})
      this.tl = tl

      tl.add('start')
        .to(
          this,
          0.5,
          {
            progress: 1,
            ease:  Elastic.easeOut.config(1.1, 0.3)
          },
          `start+=0.3`
        )
        .to(
          this,
          0.3,
          {
            ofs: 19,
            ease: Power3.easeIn
          },
          `start+=0`
        )

    },
    animateOn() {
      if (this.tl)
        this.tl.kill()
      let tl = new TimelineMax({  })
      this.tl = tl

      tl.add('start')
        .to(
          this,
          0.5,
          {
            progress: 0,
            ease:  Elastic.easeOut.config(1.1, 0.3)
          },
          `start+=0.3`
        )
        .to(
          this,
          0.3,
          {
            ofs: 0,
            ease: Power3.easeIn
          },
          `start+=0`
        )

    },

  },
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.button-switch
  width: 100%
  pointer-events: all
  //overflow: hidden
  .stroke
    stroke: $cl-lightGold
  .fill
    fill: $cl-lightGold









</style>
